import { render, staticRenderFns } from "./LcsjgTz.vue?vue&type=template&id=8162b642&"
import script from "./LcsjgTz.vue?vue&type=script&lang=js&"
export * from "./LcsjgTz.vue?vue&type=script&lang=js&"
import style0 from "./LcsjgTz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports